import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Dialog, DialogContent, DialogContentText } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

export default function SaveConfirm(props) {
  const { saveConfirmTemplate, closeModel } = props;

  return (
    <>
      <Dialog open={true}>
        <Alert severity="warning">
          <AlertTitle>Save Confirmation</AlertTitle>
        </Alert>
        <DialogContent>
          <DialogContentText style={{ marginBottom: '0px' }}>
            Changes made to this default template will be reflected in all
            tenants and properties.
          </DialogContentText>
          <DialogContentText>Are you sure you want to save?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <DialogActions>
            <Button onClick={saveConfirmTemplate}>Save</Button>
            <Button onClick={closeModel}>Cancel</Button>
          </DialogActions>
        </DialogActions>
      </Dialog>
    </>
  );
}
